import React from "react";
import "./reviewCard.scss";
import dateformat from "dateformat";

import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";

// Images
import male from "../../../assets/avatar_male.jpg";
import female from "../../../assets/avatar_female.jpg";
import unknown from "../../../assets/avatar_unknown.jpg";
import { Avatar, Grid, Rating, Skeleton } from "@mui/material";

const ReviewCard = ({ review, gender, username }) => {
  return (
    <Grid item container className="customer-reviews">
      <Grid
        item
        container
        lg={3}
        md={3}
        xs={12}
        sm={12}
        className="customer-details"
      >
        <Grid item lg={12} md={12} sm={2} xs={3} className="avatar-container">
          <Avatar
            alt="customer"
            src={gender === "M" ? male : gender === "F" ? female : unknown}
            className="avatar"
          />
        </Grid>
        <Grid item lg={12} md={12} sm={10} xs={9} className="customer-name">
          <div className="flex-column">
            <h3>
              {username ? (
                username
              ) : (
                <Skeleton animation="wave" width="100px" />
              )}
            </h3>
            <p>{dateformat(new Date(review.created_at), "dd mmm yyyy")}</p>
          </div>
        </Grid>
      </Grid>
      <Grid
        item
        container
        lg={9}
        md={9}
        sm={12}
        xs={12}
        className="customer-reviews-details"
      >
        <div>
          <Grid container rowGap={1}>
            <Grid item xs={12}>
              <Rating
                name="read-only"
                value={review.rating}
                readOnly
                sx={{ fontSize: "23px" }}
                icon={<StarRoundedIcon fontSize="inherit" />}
                emptyIcon={<StarRoundedIcon fontSize="inherit" />}
              />
            </Grid>
            <Grid item xs={12} className="verified-purchase">
              <VerifiedRoundedIcon /> <p>Verified purchase</p>
            </Grid>
            <Grid item xs={12} className="review-description">
              <p>{review.review}</p>
            </Grid>
            {/* <Grid item xs={12} className="customer-review-images">
                <Box
                  component="img"
                  src={showImage}
                  className="customer-upload-img"
                />
              </Grid> */}
            {/* <Grid item xs={12} className="like-dislike">
                            <ThumbUpOutlinedIcon className="icon" />{" "}
                            <span>123</span>{" "}
                            <ThumbDownOutlinedIcon className="icon" />{" "}
                            <span>34</span>
                          </Grid> */}
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};

export default ReviewCard;
